// 予約質問 Preferred starting date and time (JST)の質問ID
// Step2 お客様情報入力 > 予約質問表示において、このIDに該当する質問を弾くために使われる
// NOTE: カレンダーリリース前に存在している体験マスタはこの質問を持っているので、そのまま残しておく
export const WABUNKA_RESERVATION_QUESTION_PREFERRED_DATE_TIME_ID = '40ab1acb-233b-430b-a954-2275e943becb';
